// extracted by mini-css-extract-plugin
export default {"pageheader":"PageHeaders_pageheader__mMdGy","PageHeadersStyle":"PageHeaders_PageHeadersStyle__3yjRb"};